﻿import { Component } from '@angular/core';
import { Tabla } from '../../tabla';

@Component({
    template: `
    <app-tabla [tabla]="tabla"></app-tabla>
` })
export class InterHousesUserComponent {

    tabla: Tabla = {
        titulo: 'InterHouses',
        endPoint: '/rest-api/user/interhouses',
        editable: true,
        nuevo: true,
        columnas: [
            {
                name: 'ID',
                prop: 'id',
                editable: false,
                resizeable: true,
                sortable: true,
                width: 100
            },
            {
                name: 'Casa',
                prop: 'casa',
                cell: 'nombre',
                editable: true,
                casa: true,
                resizeable: true,
                sortable: true,
                width: 200
            },
            {
                name: 'Año',
                prop: 'anio',
                editable: true,
                resizeable: true,
                sortable: true,
                width: 100
            },
            {
                name: 'Puntos',
                prop: 'puntos',
                editable: true,
                resizeable: true,
                sortable: true,
                width: 100
            }
        ]
    };

}
